import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import InputMask from 'react-input-mask';
import {
    ModalRoot,
    ModalCard,
    FormLayout,
    FormLayoutGroup,
    Input
} from '@vkontakte/vkui';
import { Icon56WriteOutline } from '@vkontakte/icons';
import '@vkontakte/vkui/dist/vkui.css';
import {
    setActiveModalVKAction,
    changeFieldModalVKAction,
    sendFastWriteAction
} from './actions';

class ModalFastWrite extends React.Component {
    onChageInput = (property, value) => {
        const { dispatch } = this.props;

        dispatch(changeFieldModalVKAction(property, value));
    }

    onClose = () => {
        const { dispatch } = this.props;

        dispatch(setActiveModalVKAction(null));
    }

    onSubmit = () => {
        const { dispatch, vk } = this.props;
        const { fastWriteVK } = vk;

        if (this.checkPhone() === 'valid') {
            dispatch(sendFastWriteAction({ phone: fastWriteVK.phone, date: moment(fastWriteVK.date).format('DD.MM.YYYY HH:mm') }));
        }
    }

    checkPhone = () => {
        const { vk } = this.props;

        if (vk.fastWriteVK.phone === null) return null;
        if (vk.fastWriteVK.phone !== '') {
             if (vk.fastWriteVK.phone.indexOf('_') === -1) return 'valid';
             return 'error';
        }
        return 'error';
    }

    render() {
        const { vk } = this.props;

        return (
            <ModalRoot
                activeModal={vk.activeModal}
                onClose={() => this.onClose()}
            >
                <ModalCard
                    id="FastWrite"
                    onClose={() => this.onClose()}
                    icon={<Icon56WriteOutline />}
                    header="Быстрая запись"
                    caption="Заполните форму и наш администратор подберёт для Вас талон."
                    actions={[{
                        title: 'Записаться',
                        mode: 'primary',
                        action: this.onSubmit
                    }]}
                >
                    <FormLayout>
                        <FormLayoutGroup top="Дата и время записи">
                            <Input
                                type="datetime-local"
                                value={vk.fastWriteVK.date.format('YYYY-MM-DDTHH:mm')}
                                onChange={e => this.onChageInput('date', moment(e.currentTarget.value))}
                            />
                        </FormLayoutGroup>
                        <FormLayoutGroup top="Телефон">
                            <InputMask
                                mask="+7(999)999-99-99"
                                value={vk.fastWriteVK.phone ? vk.fastWriteVK.phone : ''}
                                type="text"
                                status={this.checkPhone()}
                                placeholder="+7(___)___-__-__"
                                onChange={e => this.onChageInput('phone', e.currentTarget.value)}
                            >
                                {inputProps => <Input {...inputProps} />}
                            </InputMask>
                        </FormLayoutGroup>
                    </FormLayout>
                </ModalCard>
            </ModalRoot>
        );
    }
}
ModalFastWrite.propTypes = {
    dispatch: PropTypes.func.isRequired,
    vk: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    vk: state.vk,
});

export default connect(mapStateToProps)(ModalFastWrite);
